import { Component, Element, h, Host, Prop, Watch } from "@stencil/core";

import { setPropsIfNull } from "../../utils/utils";

/**
 * @slot - Slot for any elements that should be vertically spaced
 */
@Component({
  tag: "stzh-cspace",
  styleUrl: "stzh-cspace.scss",
})
export class StzhCspace {
  /** Whether first top margin of first child component should be set to 0. */
  @Prop({ reflect: true }) removeFirstMargin: boolean;

  /** Whether last bottom margin of last child component should be set to 0. */
  @Prop({ reflect: true }) removeLastMargin: boolean;

  /** Whether removing first/last margin should be automatically prevented for nested cspace/richtext */
  @Prop({ reflect: true }) preventRemoveNested: "direct" | "deep" | "disabled" = "direct";

  @Element() element: HTMLStzhCspaceElement;

  @Watch("preventRemoveNested")
  preventRemoveNestedWatcher() {
    this.init();
  }

  private observer: MutationObserver;
  private rootElement: HTMLElement;

  private init = () => {
    if (!this.rootElement) {
      return;
    }

    if (this.preventRemoveNested !== "disabled") {
      const nestedCspaceOrRichtext = this.rootElement.querySelectorAll(
        this.preventRemoveNested === "deep"
          ? "stzh-cspace, stzh-richtext"
          : ":scope > stzh-cspace, :scope > .section > stzh-cspace, stzh-show > stzh-cspace, :scope > stzh-richtext, :scope > .section > stzh-richtext, stzh-show > stzh-richtext"
      );

      nestedCspaceOrRichtext.forEach(cspaceOrRichtext => {
        setPropsIfNull(cspaceOrRichtext, {
          removeFirstMargin: false,
          removeLastMargin: false,
        } as HTMLStzhCspaceElement | HTMLStzhRichtextElement);
      });
    }
  };

  componentDidRender() {
    this.init();

    this.observer.observe(this.rootElement, {
      childList: true,
      subtree: true,
    });
  }

  connectedCallback() {
    this.observer = new MutationObserver(this.init);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render() {
    const classes = {
      "stzh-cspace": true,
    };

    return (
      <Host
        has-hidden-first-margin={typeof this.removeFirstMargin === "boolean" ? this.removeFirstMargin : true}
        has-hidden-last-margin={typeof this.removeLastMargin === "boolean" ? this.removeLastMargin : true}
      >
        <div ref={el => (this.rootElement = el as HTMLElement)} class={classes}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
